import { useHookTheme } from "../../context/Theme";

export const IcoToDo = ({ Color, Size }) => {
  const { currentTheme } = useHookTheme();

  if (Color === undefined) {
    Color = currentTheme.colors.Secundary;
  }

  return (
    <svg
      id="f9966515-f79a-4354-a0fc-c22822ae3a36"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={Size}
      viewBox="0 0 688.13386 510.5"
    >
      <path
        d="M903.2874,655.4311a24.14567,24.14567,0,0,0-.00018,48.29134h.00018a24.14567,24.14567,0,0,0,0-48.29134Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        id="eddccf5f-d02a-4888-86ae-be237287dc7c"
        data-name="Path 395"
        d="M900.99634,689.60463a2.93038,2.93038,0,0,1-1.76292-.5859l-.03154-.02365-6.64007-5.07945a2.9508,2.9508,0,1,1,3.59065-4.6836l4.30091,3.29814L910.61664,669.271a2.94955,2.94955,0,0,1,4.13542-.54623l.00086.00064-.06308.08758.06479-.08758a2.95312,2.95312,0,0,1,.54559,4.13625L903.346,688.45037a2.95134,2.95134,0,0,1-2.34705,1.15076Z"
        transform="translate(-255.93307 -194.75)"
        fill="#fff"
      />
      <polygon
        points="594.783 499.316 583.351 499.315 577.915 455.219 594.787 455.221 594.783 499.316"
        fill="#ffb8b8"
      />
      <path
        d="M575.185,496.04845h22.04781a0,0,0,0,1,0,0V509.9304a0,0,0,0,1,0,0H561.30307a0,0,0,0,1,0,0v0A13.88193,13.88193,0,0,1,575.185,496.04845Z"
        fill="#2f2e41"
      />
      <polygon
        points="549.283 499.316 537.851 499.315 532.415 455.219 549.287 455.221 549.283 499.316"
        fill="#ffb8b8"
      />
      <path
        d="M529.685,496.04845h22.04781a0,0,0,0,1,0,0V509.9304a0,0,0,0,1,0,0H515.80307a0,0,0,0,1,0,0v0A13.88193,13.88193,0,0,1,529.685,496.04845Z"
        fill="#2f2e41"
      />
      <path
        d="M859.52294,541.61574a9.377,9.377,0,0,1,1.97613-14.242l-3.54085-21.13341,12.3179-5.28408,4.58121,29.9147a9.42779,9.42779,0,0,1-15.33439,10.74481Z"
        transform="translate(-255.93307 -194.75)"
        fill="#ffb8b8"
      />
      <path
        d="M763.085,531.63a9.377,9.377,0,0,0,.40388-14.37279l6.98357-20.258-11.27569-7.24646-9.46034,28.7468A9.42779,9.42779,0,0,0,763.085,531.63Z"
        transform="translate(-255.93307 -194.75)"
        fill="#ffb8b8"
      />
      <circle cx="565.70229" cy="163.07971" r="24.56103" fill="#ffb8b8" />
      <path
        d="M762.32565,516.47412a4.50216,4.50216,0,0,1-1.24536-.17627l-7.15869-2.05517a4.50764,4.50764,0,0,1-3.08765-5.55127l14.77368-52.16211,20.60205-50.5752c2.04859-5.02783,6.32862-8.32519,11.16992-8.605a11.44643,11.44643,0,0,1,10.77808,6.27686h0a15.62084,15.62084,0,0,1,.35693,13.7705l-23.417,51.21045-18.61621,45.0835A4.49773,4.49773,0,0,1,762.32565,516.47412Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        d="M835.49548,378.427l-13.64656.24261a9.07354,9.07354,0,0,1-8.8959-11.58969,21.127,21.127,0,0,0,.65552-3.01274,15.22492,15.22492,0,0,0,.08978-3.35353,4.952,4.952,0,0,0-9.55443-1.40837v0c-2.29461.03269-7.18294-.71534-9.47755-.68265-4.87206-12.48982,5.74491-28.83323,17.17382-34.97183,11.65126-6.258,26.77521.10869,31.24139,13.15167,6.19839.11141,11.23462,6.22466,12.03341,13.10631s-2.03239,14.06747-6.36329,19.3418S838.73416,378.36942,835.49548,378.427Z"
        transform="translate(-255.93307 -194.75)"
        fill="#2f2e41"
      />
      <path
        d="M790.63742,689.94922a4.51451,4.51451,0,0,1-4.46143-4.00977L781.11251,515.7041l63.78736,4.54053.04907.41016c14.41479,120.66259,9.4873,162.43164,9.43579,162.83935a4.49832,4.49832,0,0,1-5.07544,4.20264l-14.09668.33789a4.49787,4.49787,0,0,1-3.989-4.2959L818.05221,560.439a1.40645,1.40645,0,0,0-1.46606-1.05615,1.46265,1.46265,0,0,0-1.43921,1.17725l-5.08862,123.70361a4.48067,4.48067,0,0,1-4.04126,4.67041l-14.93238.99268A4.459,4.459,0,0,1,790.63742,689.94922Z"
        transform="translate(-255.93307 -194.75)"
        fill="#2f2e41"
      />
      <path
        d="M817.10592,536.04492c-.38159,0-.76245-.00586-1.145-.01758-18.34179-.55224-32.69165-14.4292-36.65258-18.66943a4.47811,4.47811,0,0,1-1.0813-4.09717l10.5813-44.76416-2.80738-38.917a38.36931,38.36931,0,0,1,10.50562-29.6333,31.66346,31.66346,0,0,1,24.38647-9.86572c17.855.852,31.94141,16.81152,32.06861,36.33252.19751,30.23486-.69263,32.312-.98487,32.99462-8.91089,20.79688-4.04419,49.98926-2.34033,58.44141a4.5164,4.5164,0,0,1-1.33716,4.1875C838.499,531.33545,828.00924,536.04443,817.10592,536.04492Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        d="M863.17062,524.666a4.4966,4.4966,0,0,1-4.38037-3.49414L847.8735,473.61475l-14.63061-54.35743a15.62109,15.62109,0,0,1,2.62719-13.52246,11.45551,11.45551,0,0,1,11.66651-4.41015c4.72876,1.07617,8.40527,5.03515,9.595,10.33252l11.95483,53.229,5.9624,53.94092a4.50858,4.50858,0,0,1-3.96264,4.96484l-7.39991.84424A4.48708,4.48708,0,0,1,863.17062,524.666Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        d="M548.93307,246.75h-267a26,26,0,0,1,0-52h267a26,26,0,0,1,0,52Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        d="M281.93307,203.25a17.5,17.5,0,0,0,0,35h267a17.5,17.5,0,0,0,0-35Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        d="M643.2874,196.4311a24.14567,24.14567,0,0,0-.00018,48.29134h.00018a24.14567,24.14567,0,0,0,0-48.29134Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        id="ad0a0ef9-b94e-459b-a18b-5e864c4f85bd"
        data-name="Path 395"
        d="M640.99634,230.60463a2.93038,2.93038,0,0,1-1.76292-.5859l-.03154-.02365-6.64007-5.07945a2.9508,2.9508,0,1,1,3.59065-4.6836l4.30091,3.29814,10.16327-13.25912a2.94955,2.94955,0,0,1,4.13542-.54623l.00086.00064-.06308.08758.06479-.08758a2.95312,2.95312,0,0,1,.54559,4.13625L643.346,229.45037a2.95134,2.95134,0,0,1-2.34705,1.15076Z"
        transform="translate(-255.93307 -194.75)"
        fill="#fff"
      />
      <path
        d="M548.93307,334.75h-267a26,26,0,0,1,0-52h267a26,26,0,0,1,0,52Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        d="M281.93307,291.25a17.5,17.5,0,0,0,0,35h267a17.5,17.5,0,0,0,0-35Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        d="M643.2874,284.4311a24.14567,24.14567,0,0,0-.00018,48.29134h.00018a24.14567,24.14567,0,0,0,0-48.29134Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
      <path
        id="b52aca83-db19-4a50-956a-5cae2a617b83"
        data-name="Path 395"
        d="M640.99634,318.60463a2.93038,2.93038,0,0,1-1.76292-.5859l-.03154-.02365-6.64007-5.07945a2.9508,2.9508,0,1,1,3.59065-4.6836l4.30091,3.29814,10.16327-13.25912a2.94955,2.94955,0,0,1,4.13542-.54623l.00086.00064-.06308.08758.06479-.08758a2.95312,2.95312,0,0,1,.54559,4.13625L643.346,317.45037a2.95134,2.95134,0,0,1-2.34705,1.15076Z"
        transform="translate(-255.93307 -194.75)"
        fill="#fff"
      />
      <path
        d="M548.93307,422.75h-267a26,26,0,0,1,0-52h267a26,26,0,0,1,0,52Z"
        transform="translate(-255.93307 -194.75)"
        fill="#e6e6e6"
      />
      <path
        d="M281.93307,379.25a17.5,17.5,0,0,0,0,35h267a17.5,17.5,0,0,0,0-35Z"
        transform="translate(-255.93307 -194.75)"
        fill="#fff"
      />
      <path
        d="M643.2874,372.4311a24.14567,24.14567,0,0,0-.00018,48.29134h.00018a24.14567,24.14567,0,0,0,0-48.29134Z"
        transform="translate(-255.93307 -194.75)"
        fill="#e6e6e6"
      />
      <path
        d="M943.06693,705.25h-209a1,1,0,0,1,0-2h209a1,1,0,0,1,0,2Z"
        transform="translate(-255.93307 -194.75)"
        fill={Color}
      />
    </svg>
  );
};
